import React, { useEffect, useState } from 'react';
import N3rveLogo from "./../../images/N3rveLogo.png"
import NavbarDesc from "./../../images/navbar_desc.png"
import Cross from "./../../images/crossicon.png"
import NavbarCross from "./../../images/navbar_cross.png"
import EnIcon from "./../../images/englishicon.png"
import JapIcon from "./../../images/japanicon.png"
import chinaicon from "./../../images/chinaicon.png"
import koreaflag from "./../../images/koreaflag.png"
import thaiflag from "./../../images/thaiflag.png"
import vietflag from "./../../images/vietflag.png"
import indoflag from "./../../images/indoflag.png"
import NavbarTranslate from "./../../images/navbar_translate.png"
import LoginBtn from "./../../images/navloginbtn.png"
import SignBtn from "./../../images/navsignupbtn.png"
import './Navbar.css'
import {Link, useNavigate, useLocation} from 'react-router-dom'
import Cookies from 'universal-cookie';
import {useTranslation} from 'react-i18next'
import i18next from "i18next"
import { useJwt, decodeToken } from "react-jwt";
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';

function Navbar() { 
  const [select,setSelect] = useState(0);
  const [languagedropdown,setLanguageDropdown] = useState(false)
  const [sellMusicDropdown,setSellMusicDropdown] = useState(false)
  const [servicesDropdown,setServicesDropdown] = useState(false)
  const navigate= useNavigate();
  const cookies = new Cookies(null ,{ path: '/' });
  const {t} = useTranslation();
  const [signedin,setSignedIn] = useState(false)
  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    // Initialize state with the current cookie values
    const [token, setToken] = useState(cookies.get('token'));
    const [staySignedIn, setStaySignedIn] = useState(cookies.get('staysignedin'));
  

  const [mobiledrawer,setMobileDrawer] = useState(false)
  const location = useLocation();

  const handleResize = () => {
    console.log(window.innerWidth)
    setDimensions({
    width: window.innerWidth,
    height: window.innerHeight,
    });
  }

  useEffect(() => {
    const checkCookieChange = () => {
      const newToken = cookies.get('token');
      const newStaySignedIn = cookies.get('staysignedin');

      // Update state if 'token' changes
      if (newToken !== token) {
        setToken(newToken);
      }

      // Update state if 'staysignedin' changes
      if (newStaySignedIn !== staySignedIn) {
        setStaySignedIn(newStaySignedIn);
      }
    };

    // Set up an interval to check for changes in the cookies
    const intervalId = setInterval(checkCookieChange, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [token, staySignedIn, cookies]);

  // This effect will run when either 'token' or 'staySignedIn' changes
  useEffect(() => {
    if (token || staySignedIn) {
      console.log('Cookie changed - Token:', token, 'Stay Signed In:', staySignedIn);
    }
    if(cookies.get('token')!==undefined && cookies.get('staysignedin')){
      setSignedIn(true)
    }else{
      setSignedIn(false)
    }
  }, [token, staySignedIn]);

  
  useEffect(()=>{
    window.addEventListener("resize", handleResize,false);
    cookies.set('artistname', "");
    cookies.set('btnclick', "");
    if(cookies.get('token')!==undefined && cookies.get('staysignedin')){
      setSignedIn(true)
    }else{
      setSignedIn(false)
    }
    console.log(cookies.get('lang'))
    if(cookies.get('lang')===undefined){
      cookies.set('lang','en')
    }
    if(cookies.get('lang')==='en'){
      i18next.changeLanguage('en');
    }
    if(cookies.get('lang')==='jp'){
      i18next.changeLanguage('jp');
    }

    console.log("Navbar refesh")
    if(location.pathname==="/"){
      setSelect(0)
    }
    if(location.pathname==="/Artist"){
      setSelect(1)
    }
    if(location.pathname==="/Producer"){
      setSelect(2)
    }
    if(location.pathname==="/label"){
      setSelect(3)
    }
    if(location.pathname==="/publishing"){
      setSelect(4)
    }
    if(location.pathname==="/monetize"){
      setSelect(5)
    }
    if(location.pathname==="/pricing"){
      setSelect(6)
    }
  },[])

  useEffect(()=>{
    console.log("App update")
    console.log(location.pathname)
    if(location.pathname==="/"){
      setSelect(0)
    }
    if(location.pathname==="/Artist"){
      setSelect(1)
    }
    if(location.pathname==="/Producer"){
      setSelect(2)
    }
    if(location.pathname==="/label"){
      setSelect(3)
    }
    if(location.pathname==="/publishing"){
      setSelect(4)
    }
    if(location.pathname==="/monetize"){
      setSelect(5)
    }
    if(location.pathname==="/pricing"){
      setSelect(6)
    }
  },[location.pathname])

  const openInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = false;

  
    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));
  
    // Open /Dashboard in a new tab
    window.open("/Dashboard", "_blank");
  };

  const openLabelInNewTab = () => {
    const fromAccountPage = false;
    const fromLogin = false;

  
    // Store the state in localStorage or sessionStorage
    localStorage.setItem('dashboardProps', JSON.stringify({ fromAccountPage, fromLogin }));
  
    // Open /Dashboard in a new tab
    window.open("/dashboard/label", "_blank");
  };


  useEffect(()=>{

  },[select])

  return (
    <div style={{position:'fixed',top:0,display:'flex',width:'100%',justifyContent:'center',backgroundImage:'linear-gradient(180deg, #101014 8.85%, rgba(24, 25, 31, 0.5) 67.19%, rgba(24, 25, 31, 0) 100%)',zIndex:'100'}}>
      {
        dimensions.width <=768 && !mobiledrawer &&
        <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',paddingLeft:'1em',paddingRight:'1em'}}>

            <img src={N3rveLogo} alt="Nerve Logo" style={{width:'9.21em',height:'1.65em',marginTop:'1.3em',cursor:'pointer'}} onClick={()=>navigate('/')} />
         

          <img src={NavbarDesc} style={{width:'2.34em',height:'2.34em',marginTop:'1.3em',cursor:'pointer',marginTop:'1em'}}  onClick={()=>setMobileDrawer(!mobiledrawer)}/>
      
        </div>
      }

    {
        dimensions.width <=768 && mobiledrawer && 
        <div className={languagedropdown?"Darkenmob":"Mobbackground"} style={{display:'flex',flexDirection:'column',width:'100%'}}>
          <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',paddingLeft:'1em'}}>
  
            <img src={N3rveLogo} alt="Nerve Logo" style={{width:'9.21em',height:'1.65em',marginTop:'1.3em',cursor:'pointer'}} onClick={()=>{setMobileDrawer(!mobiledrawer);setSelect(0);navigate('/')}}/>
    

            <img src={Cross} style={{width:'1.6em',height:'1.6em',marginTop:'1.3em',padding:'0.4em',cursor:'pointer',paddingRight:'2em'}}  onClick={()=>setMobileDrawer(!mobiledrawer)}/>
        
          </div>

         
          <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
             
          {
                  select === 1 &&
                  <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedMob"> 
                  {t('ForArtist')}
                  </div>
                </Link>
                }

                {
                  select !== 1 &&
                  <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionMob"> 
                  {t('ForArtist')}
                  </div>
                </Link>
                }

                {
                  select === 2 &&
                  <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedMob"> 
                  {t('ForProducer')}
                  </div>
                </Link>
                }

                {
                  select !== 2 &&
                  <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionMob"> 
                  {t('ForProducer')}
                  </div>
                </Link>
                }

                {
                  select === 3 &&
                  <Link to="/label" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedMob"> 
                  NEXD
                  </div>
                </Link>
                }

                {
                  select !== 3 &&
                  <Link to="/label" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionMob"> 
                  NEXD
                  </div>
                </Link>
                }

                {
                  select === 4 &&
                  <Link to="/publishing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedMob"> 
                  PUBLISHING
                  </div>
                </Link>
                }

                {
                  select !== 4 &&
                  <Link to="/publishing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionMob"> 
                  PUBLISHING
                  </div>
                </Link>
                }


                {
                  select === 5 &&
                  <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(5);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedMob"> 
                  UGC
                  </div>
                </Link>
                }

                {
                  select !== 5 &&
                  <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(5);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionMob"> 
                  UGC
                  </div>
                </Link>
                }

                {
                  select === 6 &&
                  <Link to="/pricing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(6);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedMob"> 
                  PRICING
                  </div>
                </Link>
                }

                {
                  select !== 6 &&
                  <Link to="/pricing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(6);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionMob"> 
                  PRICING
                  </div>
                </Link>
                }

              <a href="https://n3rve.ghost.io/private/?r=%2F" target="_blank"  className="Navbar-optionMob" style={{textDecoration:'none',maxWidth:'5em'}} onClick={()=>{setMobileDrawer(!mobiledrawer)}}>
              NEXUS
              </a>
         
          </div>

        
          <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'center'}}>
      
          
            <div className="NavbarLoginBtnMob" onClick={()=>navigate("/Login")}>
            {t('Login')}
            </div>
       

        
            <div className="NavbarSignupBtnMob" onClick={()=>navigate("/Signup")}>
            {t('Signup')}
            </div>
         
          </div>

          <div style={{display:'flex',flexDirection:'row',marginLeft:'0.1em',marginTop:'0.5em',paddingBottom:'0.5em'}} onMouseLeave={()=>setLanguageDropdown(false)}>
          <div className={languagedropdown?'LanguageMobActive':'LanguageMob'} onClick={()=>setLanguageDropdown(!languagedropdown)} onMouseOver={()=>setLanguageDropdown(true)} >
           <img src={NavbarTranslate} alt="Translate" style={{width:'1.25em',height:'1.25em'}}  />
          </div>
            {
              languagedropdown &&
              <div style={{backgroundColor:'transparent',marginTop:'1em'}} onMouseLeave={()=>setLanguageDropdown(false)} >
                <div style={{backgroundColor:'#1D2024',marginTop:'0.5em',border:'1px #8C8C8C solid',borderRadius:'8px',paddingTop:'0.3em',paddingBottom:'0.3em',paddingRight:'0.5em',marginLeft:'1em',display:'flex',flexDirection:'column',alignItems:'flex-start',paddingLeft:'0.5em'}} onMouseOver={()=>setLanguageDropdown(true)} onMouseLeave={()=>setLanguageDropdown(false)}>
                  <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',cursor:'pointer',marginBottom:'0.2em',padding:'0.2em',paddingRight:'0.3em'}} className='HighlightMobOption'>
                    <img src={EnIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>English</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',cursor:'pointer',marginBottom:'0.2em',padding:'0.2em',paddingRight:'0.3em'}} className='HighlightMobOption'>
                    <img src={JapIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'jp'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('jp'); cookies.set('lang', 'jp');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>日本語</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer',marginBottom:'0.2em',padding:'0.2em',paddingRight:'0.3em'}} className='HighlightMobOption'>
                    <img src={koreaflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>한국어</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer',marginBottom:'0.2em',padding:'0.2em',paddingRight:'0.3em'}} className='HighlightMobOption'>
                    <img src={chinaicon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>中文 </div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer',marginBottom:'0.2em',padding:'0.2em',paddingRight:'0.3em'}} className='HighlightMobOption'>
                    <img src={thaiflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>ไทย</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer',marginBottom:'0.2em',padding:'0.2em',paddingRight:'0.3em'}} className='HighlightMobOption'>
                    <img src={vietflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>Tiếng Việt</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer',marginBottom:'0.2em',padding:'0.2em',paddingRight:'0.3em'}} className='HighlightMobOption'>
                    <img src={indoflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>Bahasa<br/> Indonesia</div>
                  </div>
                </div>
              </div>
            }
         
          </div>

        </div>
      }

    {
        dimensions.width <=1024 && dimensions.width >768 && !mobiledrawer &&
        <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',paddingLeft:'1.2em',paddingRight:'1.2em'}}>

            <img src={N3rveLogo} alt="Nerve Logo" style={{width:'9.21em',height:'1.65em',marginTop:'1.3em',cursor:'pointer'}} onClick={()=>navigate('/')} />
         

          <img src={NavbarDesc} style={{width:'2.34em',height:'2.34em',marginTop:'1.3em',cursor:'pointer',marginTop:'1em'}}  onClick={()=>setMobileDrawer(!mobiledrawer)}/>
      
        </div>
      }

    {
        dimensions.width <=1024 && dimensions.width >768 && mobiledrawer && 
        <div className={languagedropdown?"DarkenTabbackground":"Tabbackground"} style={{display:'flex',flexDirection:'column',width:'100%',position:'relative'}}>
          <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between',paddingLeft:'1.2em',paddingRight:'3em'}}>
  
            <img src={N3rveLogo} alt="Nerve Logo" style={{width:'9.21em',height:'1.65em',marginTop:'1.3em',cursor:'pointer'}} onClick={()=>{setMobileDrawer(!mobiledrawer);setSelect(0);navigate('/')}}/>
    

            <img src={Cross} style={{width:'1.6em',height:'1.6em',marginTop:'1.3em',marginRight:'2em',cursor:'pointer'}}  onClick={()=>setMobileDrawer(!mobiledrawer)}/>
        
          </div>

       
          <div style={{display:'flex',flexDirection:'column',marginLeft:'1.5em'}}>
             
                {
                  select === 1 &&
                  <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedTab"> 
                  {t('ForArtist')}
                  </div>
                </Link>
                }

                {
                  select !== 1 &&
                  <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionTab"> 
                  {t('ForArtist')}
                  </div>
                </Link>
                }

                {
                  select === 2 &&
                  <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedTab"> 
                  {t('ForProducer')}
                  </div>
                </Link>
                }

                {
                  select !== 2 &&
                  <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionTab"> 
                  {t('ForProducer')}
                  </div>
                </Link>
                }

                {
                  select === 3 &&
                  <Link to="/label" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedTab"> 
                  NEXD
                  </div>
                </Link>
                }

                {
                  select !== 3 &&
                  <Link to="/label" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionTab"> 
                  NEXD
                  </div>
                </Link>
                }

                {
                  select === 4 &&
                  <Link to="/publishing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedTab"> 
                  PUBLISHING
                  </div>
                </Link>
                }

                {
                  select !== 4 &&
                  <Link to="/publishing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionTab"> 
                  PUBLISHING
                  </div>
                </Link>
                }


                {
                  select === 5 &&
                  <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(5);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedTab"> 
                  UGC
                  </div>
                </Link>
                }

                {
                  select !== 5 &&
                  <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(5);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionTab"> 
                  UGC
                  </div>
                </Link>
                }

                {
                  select === 6 &&
                  <Link to="/pricing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(6);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Artist-SelectedTab"> 
                  PRICING
                  </div>
                </Link>
                }

                {
                  select !== 6 &&
                  <Link to="/pricing" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(6);setMobileDrawer(!mobiledrawer)}}>
                  <div className="Navbar-optionTab"> 
                  PRICING
                  </div>
                </Link>
                }

              <a href="https://n3rve.ghost.io/private/?r=%2F" target="_blank"  className="Navbar-optionTab" style={{textDecoration:'none',maxWidth:'5em'}} onClick={()=>{setMobileDrawer(!mobiledrawer)}}>
              NEXUS
              </a>
         
          </div>
          

        {/* {select==1 && 
          <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
             <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab"> 
                ABOUT
              </div>
            </Link>

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Artist-SelectedTab"> 
              {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab">
              {t('ForProducer')}
              </div>
            </Link>

            <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab">
               MONETIZATON
              </div> 
            </Link>
          </div>
          }

        {select==2 && 
          <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
             <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab"> 
                ABOUT
              </div>
            </Link>

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab"> 
              {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);}}>
              <div className="Artist-SelectedTab">
              {t('ForProducer')}
              </div>
            </Link>

            <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab">
               MONETIZATON
              </div> 
            </Link>
          </div>
          }

        {select==3 && 
          <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
             <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab"> 
                ABOUT
              </div>
            </Link>

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab"> 
              {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);}}>
              <div className="Navbar-optionTab">
              {t('ForProducer')}
              </div>
            </Link>

            <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
              <div className="Artist-SelectedTab">
               MONETIZATON
              </div> 
            </Link>
          </div>
          } 

      {select==4 && 
          <div style={{display:'flex',flexDirection:'column',marginLeft:'1.5em'}}>
             <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Artist-SelectedTab"> 
                ABOUT
              </div>
            </Link>

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab"> 
                {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab">
               {t('ForProducer')}
              </div>
            </Link>

            <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);setMobileDrawer(!mobiledrawer)}}>
              <div className="Navbar-optionTab">
               MONETIZATON
              </div> 
            </Link>
          </div>
          } */}

         

          <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'flex-start',height:'4em',marginLeft:'1em'}}>
          {
            !signedin &&
          <div className="NavbarLoginBtn" style={{width:'5.5em'}} onClick={()=>navigate("/Login")}>
            {t('Login')}
            </div>
          }

          {
            !signedin &&
            <div className="NavbarSignupBtn" style={{width:'5.5em'}} onClick={()=>navigate("/Signup")}>
            {t('Signup')}
            <div className="HoverOverlay" style={{borderRadius:'999px'}} />
            </div>
          }   

          {
            signedin &&
            <div className="NavbarSignupBtn" style={{width:'5.5em'}} onClick={()=> navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:false}})}>
             Dashboard
             <div className="HoverOverlay" style={{borderRadius:'999px'}}/>
            </div>
          }    
          {/* {
            !signedin &&
            <div className="NavbarLoginBtn" onClick={()=>navigate("/Login")}>
            {t('Login')}
            </div>
          }

          {
            !signedin &&
            <div className="NavbarSignupBtn" onClick={()=>navigate("/Signup")}>
            {t('Signup')}
            <div className="HoverOverlay" style={{borderRadius:'999px'}} />
            </div>
          }

          {
            signedin &&
            <div className="NavbarSignupBtn" onClick={()=> navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:false}})}>
             Dashboard
             <div className="HoverOverlay" style={{borderRadius:'999px'}}/>
            </div>
          }    */}
          
            {/* <div className="NavbarLoginBtnMob" onClick={()=>navigate("/Login")}>
            {t('Login')}
            </div>
       

        
            <div className="NavbarSignupBtnMob" onClick={()=>navigate("/Signup")}>
            {t('Signup')}
            </div> */}
         
          </div>

         <div style={{position:'relative'}}>
          <div className={languagedropdown?'LanguageTabactive':'LanguageTab'} onMouseOver={()=>setLanguageDropdown(true)} onClick={()=>setLanguageDropdown(!languagedropdown)} onMouseLeave={()=>setLanguageDropdown(false)}>
          <img src={NavbarTranslate} alt="Translate" style={{width:'1.25em',height:'1.25em',cursor:'pointer',zIndex:'2'}} className='LanguageTabIcon'/>
          </div>
            {
             languagedropdown &&
              <div style={{backgroundImage:'linear-gradient(180deg, #101014 8.85%, rgba(24, 25, 31, 0.8) 100.19%, rgba(24, 25, 31, 0) 100%)',width:'40em',position:'absolute',left:'1.8em',bottom:'1.7em'}} onMouseLeave={()=>setLanguageDropdown(false)} >
                <div style={{backgroundColor:'#1D2024',marginTop:'0.4em',border:'1px #8C8C8C solid',borderRadius:'8px',paddingTop:'0.3em',paddingBottom:'0.3em',paddingLeft:'0.5em',paddingRight:'0.5em',position:'absolute',bottom:'-1.9em',marginLeft:'2em',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}} onMouseOver={()=>setLanguageDropdown(true)} onMouseLeave={()=>setLanguageDropdown(false)}>
                  <div  className="LangTabHover" style={{display:'flex',flexDirection:'row',cursor:'pointer',alignItems:'center',paddingBottom:'0.625em',paddingTop:'0.625em',paddingRight:'0.625em',paddingLeft:'0.625em',marginRight:'1em',borderRadius:'99px'}}>
                    <img src={EnIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>English</div>
                  </div>

                  <div className="LangTabHover" style={{display:'flex',flexDirection:'row',cursor:'pointer',alignItems:'center',paddingBottom:'0.625em', paddingTop:'0.625em',paddingRight:'0.625em',paddingLeft:'0.625em',marginRight:'1em',borderRadius:'99px'}}>
                    <img src={JapIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'jp'} style={{transform:'none',writingMode:'horizontal-tb',textOrientation:'mixed'}} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('jp'); cookies.set('lang', 'jp');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>日本語</div>
                  </div>

                  <div className="LangTabHover" style={{display:'flex',flexDirection:'row',cursor:'pointer',alignItems:'center',paddingBottom:'0.625em', paddingTop:'0.625em',paddingRight:'0.625em',paddingLeft:'0.625em',marginRight:'1em',borderRadius:'99px'}}>
                    <img src={koreaflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>한국어</div>
                  </div>

                  <div className="LangTabHover" style={{display:'flex',flexDirection:'row',cursor:'pointer',alignItems:'center',paddingBottom:'0.625em', paddingTop:'0.625em',paddingRight:'0.625em',paddingLeft:'0.625em',borderRadius:'99px'}}>
                    <img src={chinaicon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>中文</div>
                  </div>

                  <div className="LangTabHover" style={{display:'flex',flexDirection:'row',cursor:'pointer',alignItems:'center',paddingBottom:'0.625em', paddingTop:'0.625em',paddingRight:'0.625em',paddingLeft:'0.625em',borderRadius:'99px'}}>
                    <img src={thaiflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>ไทย</div>
                  </div>

                  <div className="LangTabHover" style={{display:'flex',flexDirection:'row',cursor:'pointer',alignItems:'center',paddingBottom:'0.625em', paddingTop:'0.625em',paddingRight:'0.625em',paddingLeft:'0.625em',borderRadius:'99px'}}>
                    <img src={vietflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>Tiếng Việt</div>
                  </div>

                  <div className="LangTabHover" style={{display:'flex',flexDirection:'row',cursor:'pointer',alignItems:'center',paddingBottom:'0.625em', paddingTop:'0.625em',paddingRight:'0.625em',paddingLeft:'0.625em',borderRadius:'99px'}}>
                    <img src={indoflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown);setMobileDrawer(!mobiledrawer)}}>Bahasa Indonesia</div>
                  </div>
                </div>
              </div>
            }
         </div>
    

        </div>
      }


    {
        dimensions.width >1024 &&
        <div className="Navbar">

         
        <Link to="/" style={{ textDecoration: 'none' }}  onClick={()=>{setSelect(0);}}>
              <img src={N3rveLogo} alt="Nerve Logo" style={{width:'9.21em',height:'1.65em',marginTop:'1.3em',marginLeft:'0em'}}/>
        </Link>
        

        <div className='Navbar-menu'>
        
          <div style={{display:'flex',flexDirection:'row'}}>
              <div className="NavbarMainOption" style={{position:'relative'}} onMouseOver={()=>setSellMusicDropdown(true)} onMouseLeave={()=>setSellMusicDropdown(false)}>
              SELL YOUR MUSIC
              {
                sellMusicDropdown &&
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',position:'absolute',backgroundColor:'rgba(29, 32, 36, 95%)',width:'17.15em',paddingTop:'0.61em',paddingBottom:'0.61em',borderRadius:'4px',top:'3.5em',left:'0em'}}>
                <div className='NavbarMenuOption' onClick={()=>{setSellMusicDropdown(false);navigate("/Artist")}}>
                  FOR ARTISTS
                </div>
                <div className='NavbarMenuOption' onClick={()=>{setSellMusicDropdown(false);navigate("/Producer")}}>
                  FOR PRODUCERS
                </div>
                <div className='NavbarMenuOption' onClick={()=>{setSellMusicDropdown(false);navigate("/label")}} >
                 NEXD
                </div>
              </div>
              }
              
              </div>

              <div className="NavbarMainOption" style={{position:'relative'}} onMouseOver={()=>setServicesDropdown(true)} onMouseLeave={()=>setServicesDropdown(false)}>
              SERVICES
              {
                servicesDropdown &&
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',position:'absolute',backgroundColor:'rgba(29, 32, 36, 95%)',width:'12.315em',paddingTop:'0.61em',paddingBottom:'0.61em',borderRadius:'4px',top:'3.5em',left:'0em'}}>
                <div className='NavbarMenuOption' onClick={()=>{setServicesDropdown(false);navigate("/publishing")}}>
                  PUBLISHING
                </div>
                <div className='NavbarMenuOption' onClick={()=>{setServicesDropdown(false);navigate("/monetize")}}>
                  UGC
                </div>

              </div>
              }
              </div>

              <div className="NavbarMainOption" onClick={()=>{navigate("/pricing")}}>
              PRICING
              </div>

             
              <a href="https://n3rve.ghost.io/private/?r=%2F" target="_blank"  className="NavbarMainOption" style={{textDecoration:'none'}}>
              NEXUS
              </a>
          </div>

          {/* {select==0 && 
          <div style={{display:'flex',flexDirection:'row'}}>
             <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);}}>
              <div className="Navbar-option"> 
               ABOUT
              </div>
            </Link>

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);}}>
              <div className="Navbar-option"> 
                {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);}}>
              <div className="Navbar-option">
               {t('ForProducer')}
              </div>
            </Link>

              <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);}}>
              <div className="Navbar-option">
               MONETIZATON
              </div>
            </Link>
          </div>
          }

        {select==1 && 
          <div style={{display:'flex',flexDirection:'row'}}>
            <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);}}>
              <div className="Navbar-option"> 
               ABOUT
              </div>
            </Link>
           

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);}}>
              <div className="Artist-Selected" > 
              {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);}}>
              <div className="Navbar-option">
              {t('ForProducer')}
              </div>
            </Link>

               <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);}}>
              <div className="Navbar-option">
              MONETIZATON
              </div>
            </Link>
          </div>
          }

        {select==2 && 
          <div style={{display:'flex',flexDirection:'row'}}>
             <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);}}>
              <div className="Navbar-option"> 
               ABOUT
              </div>
            </Link>

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);}}>
              <div className="Navbar-option"> 
              {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);}}>
              <div className="Artist-Selected">
              {t('ForProducer')}
              </div>
            </Link>

             <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);}}>
              <div className="Navbar-option">
              MONETIZATON
              </div>
            </Link>
            
          </div>
          }

    {select==3 && 
          <div style={{display:'flex',flexDirection:'row'}}>
            <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);}}>
              <div className="Navbar-option"> 
               ABOUT
              </div>
            </Link>

              <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);}}>
              <div className="Navbar-option"> 
              {t('ForArtist')}
              </div>
            </Link>

            <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);}}>
              <div className="Navbar-option">
              {t('ForProducer')}
              </div>
            </Link>

            <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);}}>
              <div className="Artist-Selected">
              MONETIZATON
              </div>
            </Link>
          </div>
          }

    {select==4 && 
              <div style={{display:'flex',flexDirection:'row'}}>
                <Link to="/about" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(4);}}>
                  <div className="Artist-Selected"> 
                  ABOUT
                  </div>
                </Link>
                
                  <Link to="/Artist" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(1);}}>
                  <div className="Navbar-option"> 
                  {t('ForArtist')}
                  </div>
                </Link>

                <Link to="/Producer" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(2);}}>
                  <div className="Navbar-option">
                  {t('ForProducer')}
                  </div>
                </Link>

                <Link to="/monetize" style={{ textDecoration: 'none' }} onClick={()=>{setSelect(3);}}>
                  <div className="Navbar-option">
                  MONETIZATON
                  </div>
                </Link>
              </div>
              }
             */}

          <div style={{display:'flex',flexDirection:'column'}}>
          <div className={languagedropdown?"Translate-iconactive":"Translate-icon"} >
          <img src={NavbarTranslate} alt="Translate" style={{cursor:'pointer'}} className="Translate-iconimg" onMouseOver={()=>setLanguageDropdown(true)} />
          </div>
            {
              languagedropdown &&
              <div style={{backgroundColor:'transparent',paddingTop:'3em',marginTop:'-2em',cursor:'pointer'}} onMouseLeave={()=>setLanguageDropdown(false)} >
                <div style={{backgroundColor:'#1D2024',marginTop:'0.4em',paddingBottom:'0.3em',border:'1px #8C8C8C solid',borderRadius:'8px',paddingTop:'0.3em',position:'absolute',top:'3em',marginLeft:'-1.5em'}} onMouseOver={()=>setLanguageDropdown(true)} onMouseLeave={()=>setLanguageDropdown(false)}>
                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em',paddingLeft:'0.5em',paddingRight:'0.5em',paddingTop:'0.2em',paddingBottom:'0.2em'}} className='HoverLang'>
                    <img src={EnIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown)}}>English</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em',paddingLeft:'0.5em',paddingRight:'0.5em',paddingTop:'0.2em',paddingBottom:'0.2em'}} className='HoverLang'>
                    <img src={JapIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'jp'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('jp'); cookies.set('lang', 'jp');setLanguageDropdown(!languagedropdown)}}>日本語</div>
                  </div>


                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em',paddingLeft:'0.5em',paddingRight:'0.5em',paddingTop:'0.2em',paddingBottom:'0.2em'}} className='HoverLang'>
                    <img src={koreaflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown)}}>한국어</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em',paddingLeft:'0.5em',paddingRight:'0.5em',paddingTop:'0.2em',paddingBottom:'0.2em'}} className='HoverLang'>
                    <img src={chinaicon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown)}}>中文</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em',paddingLeft:'0.5em',paddingRight:'0.5em',paddingTop:'0.2em',paddingBottom:'0.2em'}} className='HoverLang'>
                    <img src={thaiflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown)}}>ไทย</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em',paddingLeft:'0.5em',paddingRight:'0.5em',paddingTop:'0.2em',paddingBottom:'0.2em'}} className='HoverLang'>
                    <img src={vietflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown)}}>Tiếng Việt</div>
                  </div>

                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'0.5em',paddingRight:'0.5em',paddingTop:'0.2em',paddingBottom:'0.2em'}} className='HoverLang'>
                    <img src={indoflag} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                    <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguageDropdown(!languagedropdown)}}>Bahasa <br/> Indonesia</div>
                  </div>
                </div>
              </div>
            }
         
          </div>

          {
            !signedin &&
            <div className="NavbarLoginBtn" onClick={()=>navigate("/Login")}>
            {t('Login')}
            </div>
          }

          {
            !signedin &&
            <div className="NavbarSignupBtn" onClick={()=>navigate("/Signup")}>
            {t('Signup')}
            <div className="HoverOverlay" style={{borderRadius:'999px'}} />
            </div>
          }

          {
            signedin &&
            <div className="NavbarSignupBtn" onClick={()=> 
              { if(cookies.get('token')!==undefined){
                if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                  openInNewTab()
                }
          
                if(decodeToken(cookies.get('token')).info.role==="label"){
                  openLabelInNewTab()
                }
                
              }
               
              }
            // navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:false}})
           }>
             Dashboard
             <div className="HoverOverlay" style={{borderRadius:'999px'}}/>
            </div>
          }   
         

          
        </div>
      </div>
      }
     
      
    </div>
  );
}

export default Navbar;